var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.items),function(item,idx){return _c('li',{key:item.id},[_c('span',{staticClass:"canvas-item-list__item-label",on:{"click":function($event){_vm.onClickOnDelete(idx)}}},[_vm._v("\n        "+_vm._s(item.label)+"\n        "),_c('i',{staticClass:"material-icons"},[_vm._v("delete_outline")])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd51498","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CanvasItemList.vue
// module id = 241
// module chunks = 1